export default __webpack_public_path__ + "static/media/m1_logo.60dedd86.png";